import script from "./LayoutDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutDashboard.vue?vue&type=script&setup=true&lang=js"

import "./LayoutDashboard.vue?vue&type=style&index=0&id=22ffc43f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22ffc43f"]])

export default __exports__